import { Button } from "primereact/button";
import PencilIcon from "@/assets/icons/equipe-pencil.svg?react";
import { REVISAO } from "../../../nova-obra.constants";
import styles from "../../etapa-revisao.module.scss";
import type { SecaoProps, SecaoViewModel } from "./types-secao";

/** `secao / *` do Figma com o `revisao/cabecalho-secao`; o "Editar" é exigido pela HU (Impasse 12). */
export function SecaoView({
  Icone,
  titulo,
  onEditar,
  children,
  testIds,
  rotuloEditar,
}: SecaoProps & SecaoViewModel) {
  return (
    <section className={styles.secao} data-testid={testIds.secao} aria-label={titulo}>
      <header className={styles.cabecalho}>
        <Icone className={styles.cabecalhoIcone} aria-hidden />
        <h3 className={styles.cabecalhoTitulo}>{titulo}</h3>
        <Button
          type="button"
          size="small"
          icon={<PencilIcon aria-hidden />}
          label={REVISAO.editar}
          severity="secondary"
          className={styles.editar}
          aria-label={rotuloEditar}
          onClick={onEditar}
          data-testid={testIds.editar}
        />
      </header>
      <div className={styles.conteudo}>{children}</div>
    </section>
  );
}
